import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from './redux.hooks';

interface IUseEdit<T> {
  name: string;
  data: T | null;
  setPayload: (x: T) => any;
  callback?: (x?: any) => any;
  getState: () => void;
  excludes?: (keyof T)[];
  action?: 'create' | 'edit';
}

type IParams = {
  action: 'create' | 'edit';
  slug?: string;
  id?: string;
};

export const useEdit = <T>({
  name,
  data,
  excludes,
  action,
  getState,
  callback,
  setPayload,
}: IUseEdit<T>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let { slug, id } = useParams<IParams>();
  const [edit, setEdit] = React.useState<boolean>(false);

  const navigateToPage = React.useCallback(() => {
    navigate(`/dashboard/${name}`);
  }, [navigate, name]);

  React.useEffect(() => {
    if (edit && data && data !== null) {
      let br: any = { ...data };

      if (excludes?.length) {
        excludes.forEach((key) => {
          if (br[key]) {
            br[key] = null;
          }
        });
      }

      if (name === 'coupons') {
        setPayload({ ...br, kitchenId: br.kitchen?.id || undefined });
      } else {
        setPayload(br);
      }

      callback && callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, edit, setPayload, callback]);

  React.useEffect(() => {
    action && action !== 'create' && action !== 'edit' && navigateToPage();

    if (action === 'edit' && (slug || id)) {
      setEdit(true);
      getState();
    } else if (action === 'create' && (slug || id)) {
      navigateToPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, navigateToPage, slug, id, dispatch]);

  return { edit };
};
